(() => {
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  class ScrollStory extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.video = this.querySelector('video');
      this.chapters = [...this.querySelectorAll('[data-chapter]')];
      this.dots = [...this.querySelectorAll('.story-dots i')];
      this.toggle = this.querySelector('.motion-toggle');
      this.activeChapter = -1;
      this.onScroll = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
      this.onSeeked = () => { this.seeking = false; this.flushSeek(); };
      this.onLoaded = () => { if (this.video.duration > 0 && this.motion) { this.classList.add('has-video'); this.update(); } };
      this.onError = () => this.disable();
      this.onPreference = () => { if (mediaQuery.matches) this.disable(); };
      this.onToggle = () => this.motion ? this.disable(true) : this.enable(true);
      this.video.addEventListener('seeked', this.onSeeked);
      this.video.addEventListener('loadeddata', this.onLoaded);
      this.video.addEventListener('error', this.onError);
      this.toggle.addEventListener('click', this.onToggle);
      mediaQuery.addEventListener('change', this.onPreference);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      const saveData = navigator.connection && navigator.connection.saveData;
      if (this.dataset.enabled === 'true' && !mediaQuery.matches && !saveData) this.enable();
      else this.disable();
      if (this.dataset.enabled === 'true' && !mediaQuery.matches) this.toggle.hidden = false;
    }
    enable(fromButton = false) {
      if (mediaQuery.matches) return;
      this.motion = true;
      this.classList.remove('scroll-story--static');
      this.toggle.textContent = 'Turn motion off';
      if (!this.video.src) {
        this.video.muted = true;
        this.video.src = window.matchMedia('(max-width: 749px)').matches ? this.dataset.mobile : this.dataset.desktop;
        this.video.preload = 'auto';
        this.video.load();
      }
      if (fromButton) this.scrollIntoView({ block: 'start', behavior: 'instant' });
      this.update();
    }
    disable(fromButton = false) {
      const rect = this.getBoundingClientRect();
      const wasInside = rect.top < 0 && rect.bottom > 0;
      this.motion = false;
      this.classList.add('scroll-story--static');
      this.classList.remove('has-video');
      this.toggle.textContent = 'Turn motion on';
      this.setChapter(0);
      if (this.video) this.video.pause();
      if (fromButton && wasInside) this.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    setChapter(index) {
      if (this.activeChapter === index) return;
      this.activeChapter = index;
      this.chapters.forEach((chapter, i) => {
        const active = i === index;
        chapter.classList.toggle('is-current', active);
        chapter.setAttribute('aria-hidden', String(!active));
        chapter.inert = !active;
        this.dots[i]?.classList.toggle('active', active);
      });
    }
    update() {
      if (!this.motion) return;
      const rect = this.getBoundingClientRect();
      const stage = this.querySelector('.story-stage');
      const top = parseFloat(getComputedStyle(stage).top) || 0;
      const distance = Math.max(1, this.offsetHeight - stage.offsetHeight);
      const progress = Math.max(0, Math.min(1, (top - rect.top) / distance));
      this.setChapter(progress < .34 ? 0 : progress < .69 ? 1 : 2);
      if (Number.isFinite(this.video.duration) && this.video.duration > 0) {
        this.targetTime = progress * Math.max(0, this.video.duration - .05);
        this.flushSeek();
      }
    }
    flushSeek() {
      if (!this.motion || this.seeking || this.video.readyState < 2 || this.targetTime === undefined) return;
      if (Math.abs(this.video.currentTime - this.targetTime) < .035) return;
      try { this.seeking = true; this.video.currentTime = this.targetTime; }
      catch { this.seeking = false; }
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      mediaQuery.removeEventListener('change', this.onPreference);
      this.video.removeEventListener('seeked', this.onSeeked);
      this.video.removeEventListener('loadeddata', this.onLoaded);
      this.video.removeEventListener('error', this.onError);
      this.toggle.removeEventListener('click', this.onToggle);
      cancelAnimationFrame(this.frame);
      this.initialized = false;
    }
  }
  if (!customElements.get('scroll-story')) customElements.define('scroll-story', ScrollStory);
  function initNavigation(root = document) {
    root.querySelectorAll('.menu-toggle').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const menu = document.getElementById(button.getAttribute('aria-controls'));
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        menu.hidden = !open;
      });
    });
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const button = document.querySelector('.menu-toggle[aria-expanded="true"]');
    if (button) { button.click(); button.focus(); }
    document.querySelectorAll('.nav-dropdown[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.nav-dropdown[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('shopify:section:load', event => initNavigation(event.target));
  initNavigation();
})();
